import Option from './Option'
import isSelected from '../isSelected'

function Options(props) {
    const { options, renderOption ,optionProps, snapshot, disabled} = props
    return (
        <ul className='select-search-options' >
            {options.map((o) => {
                return (
                    <Option
                        key={o.value}
                        option={o}
                        optionProps={optionProps}
                        renderOption={renderOption}
                        selected={isSelected(o, snapshot.option)}
                        highlighted={snapshot.highlighted === o.index}
                        disabled={o.disabled || disabled}
                    />
                )
            })}
        </ul>
    )
}

export default Options